import React, { useEffect, useState } from 'react';
import Page from "../../components/Page";
import _ from 'lodash';
import {
    useNavigate,
    // useHistory 
} from 'react-router-dom';
import {
    getModuleListing, getModueleListingClear, getModuleListingBroker,
    getModuleListingClear, getModuleListingClearBroker, getCourseDetailEcom
} from "../../redux/courses/actions";
import { clickStreamUser, convertTimeFormat, SessionKeys } from "../../utils/AppUtils";
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import ProgressBar from 'react-bootstrap/ProgressBar'
import moment from 'moment';
import ModuleSection from '../../components/Module/ModuleSection';
import Loader from "../../components/Loader/Loader";
import ModuleSectionB2C from '../../components/Module/ModuleSectionB2C';
import API_LIST from '../../utils/apiList';
import CONFIG from '../../utils/config';
import useLogin from '../../custom-hooks/useLogin';
import RecommendationDetailPage from '../B2C-Pages/RecommendationDetailPage';

const ModuleDetail = () => {
    // const history = useHistory()
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { isLoggedIn } = useLogin();
    const [moduleList, setModuleList] = useState([])
    const [moduleData, setModuleData] = useState({})
    const [courseBrokerId, setCourseBrokerId] = useState('')
    const auth = useSelector(state => state.auth)
    const { courseId } = useParams();
    const search = window.location.search;
    const params = new URLSearchParams(search);

    const c = params.get("c");
    let decodedString = atob(c);
    let paramsReq = JSON.parse(sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES" ? "{}" : decodedString);
    const source = paramsReq.source;
    const via_lp = paramsReq.via_lp;
    const lp_id = paramsReq.lp_id;
    const via_cat = paramsReq.via_cat;
    const catId = paramsReq.catId;
    const level_id = paramsReq.level_id;
    const is_level = paramsReq.is_level;
    const cid = paramsReq.cid;
    const from = paramsReq.from;
    const lp_source = paramsReq.lp_source;
    const provider_id = paramsReq?.provider_id;
    const provider_name = paramsReq?.provider_name

    // const source = params.get('source');
    // const via_lp = params.get('via_lp');
    // const lp_id = params.get('lp_id');
    // const via_cat = params.get('via_cat');
    // const catId = params.get('catId');
    // const level_id = params.get('level_id');
    // const is_level = params.get('is_level');
    // const cid = params.get("cid");
    // const from = params.get("from");
    // const lp_source = params.get("lp_source");

    const [isLoading, setIsLoading] = useState(false);

    const moduleListingData = useSelector(state => state.courses.moduleListing);
    const courseDetailEcom = useSelector(state => state.courses.courseDetailEcom);
    const moduleListingDataBroker = useSelector(state => state.courses.moduleListingBroker);
    const addToCartRes = useSelector((state) => state.product.addToCart);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES") {
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 1000)
        }
    }, [])

    useEffect(() => {
        if (!_.isEmpty(addToCartRes)) {
            setIsLoading(false)
            let reqBody = {
                token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                session_id: localStorage.getItem(SessionKeys.SESSION_ID),
                entity_id: cid,
            }
            if (from === "lp") {
                reqBody.lp_id = lp_id;
            } else if (from === "bundle") {
                reqBody.bundle_id = lp_id;
            }
            dispatch(
                getCourseDetailEcom({
                    URL: `${CONFIG.API_URL_BROKER}${API_LIST.ECOM_API.COURSE_DETAIL_ECOM}`,
                    payload: reqBody,
                    method: "post",
                    isJSON: true
                })
            )
        }
    }, [addToCartRes]);

    useEffect(() => {
        console.log(courseDetailEcom)
        if (source === 'xsel' || source === 'ecom') {
            if (!_.isEmpty(courseDetailEcom) &&
                courseDetailEcom.status === 'success') {
                setIsLoading(false);
                // console.log(courseDetailEcom.payload.data)
                let modulesInfo = _.cloneDeep(courseDetailEcom.payload.data)
                modulesInfo?.modules?.sort((a, b) => parseFloat(a.module_sequence) - parseFloat(b.module_sequence));
                if (!_.isEmpty(modulesInfo)) {
                    if (modulesInfo.modules.length > 0) {
                        modulesInfo.modules[0].isLock = false;
                        for (let [index, modules] of modulesInfo.modules.entries()) {
                            modules.isLock = modules.isLock === false ? modules.isLock : true;
                            if (modules.progress > 0) {
                                modules.isLock = false;
                                if ((index + 1) !== modulesInfo.modules.length)
                                    modulesInfo.modules[index + 1].isLock = _.toNumber(modules.progress) === 100 ? false : true;
                            }
                            if (!isLoggedIn && !modules.is_teaser) {
                                modules.isLock = true;
                            }
                        }
                        for (let modules of modulesInfo.modules) {
                            const hour = moment(modules.duration, 'hh:mm').hours();
                            const min = moment(modules.duration, 'hh:mm').minutes();
                            if (hour > 0) {
                                modules.durationTime = hour > 1 ? `${hour} hours` : `${hour} hour`;
                            }
                            if (min > 0) {
                                modules.durationTime = min > 1
                                    ? modules.durationTime ? `${modules.durationTime} ${min} minutes` : `${min} minutes`
                                    : modules.durationTime ? `${modules.durationTime} ${min} minute` : `${min} minute`;
                            }
                        }
                    }
                    setModuleData(modulesInfo);
                    // console.log("Modulelisting datas", modulesInfo, source);
                } else {
                    setModuleData({});
                }

            }
        } else {
            if (!_.isEmpty(moduleListingDataBroker) &&
                moduleListingDataBroker.status === 'success') {
                setIsLoading(false);
                // console.log(moduleListingDataBroker.payload)
                let modulesInfo = _.cloneDeep(moduleListingDataBroker.payload)
                modulesInfo?.modules?.sort((a, b) => parseFloat(a.module_sequence) - parseFloat(b.module_sequence));
                if (!_.isEmpty(modulesInfo)) {

                    if (modulesInfo?.modules?.length > 0) {
                        setCourseBrokerId(modulesInfo.courseId)
                        modulesInfo.modules[0].isLock = false;
                        for (let [index, modules] of modulesInfo.modules.entries()) {
                            modules.isLock = modules.isLock === false ? modules.isLock : true;
                            // module.progress = module.crs_progress
                            if (modules.progress > 0) {
                                modules.isLock = false;
                                if ((index + 1) !== modulesInfo.modules.length)
                                    modulesInfo.modules[index + 1].isLock = _.toNumber(modules.progress) === 100 ? false : true;
                            }

                            if (!isLoggedIn && !modules.is_teaser) {
                                modules.isLock = true;
                            }
                        }
                        for (let modules of modulesInfo.modules) {
                            const hour = moment(modules.time_hrs, 'hh').hours();
                            const min = moment(modules.time_min, 'mm').minutes();
                            // module.durationTime = convertTimeFormat(hour * 60 + min)
                            // console.log(module.durationTime)
                            if (hour > 0) {
                                modules.durationTime = hour > 1 ? `${hour} hours` : `${hour} hour`;
                            }
                            if (min > 0) {
                                modules.durationTime = min > 1
                                    ? modules.durationTime ? `${modules.durationTime} ${min} minutes` : `${min} minutes`
                                    : modules.durationTime ? `${modules.durationTime} ${min} minute` : `${min} minute`;
                            }
                        }
                        if (source === 'broker') {
                            // console.log('Modulelisting data change module')
                            for (let modules of modulesInfo.modules) {
                                modules.module_id = modules.id;
                            }
                        }
                    }

                    setModuleData(modulesInfo);
                    // console.log("Modulelisting data", modulesInfo);
                } else {
                    setModuleData({});
                }

            }
        }
    }, [courseDetailEcom, moduleListingDataBroker])

    useEffect(() => {


        clickStreamUser('module_detail_page', {
            courseId: courseId,
            userId: auth.authBroker?.payload?.user.user_id,
        })
    }, [courseId, source, dispatch, auth.authBroker])

    const navigateToDetails = (title, progress, m) => {
        if (!m.isLock) {
            // console.log("Module", m);
            let courseID = source === 'broker' ? courseBrokerId : courseId;
            if (isLoggedIn) {
                clickStreamUser('module_click_goto', {
                    moduleId: m.module_id,
                    moduleName: m.title,
                    courseName: moduleData.courseName,
                    courseId: courseID,
                    userId: auth?.authBroker?.payload.user.user_id
                })
            }
            let paramsReq = {
                source: source,
                cid: cid,
                from: from,
            }
            if(provider_id)
                {
                    paramsReq.provider_id = provider_id;
                    paramsReq.provider_name = provider_name;
                }

            if (from === "lp" || via_lp === "true") {
                paramsReq.via_lp = "true";
                paramsReq.lp_id = lp_id;
                paramsReq.lp_source = lp_source;
                if (is_level === 'true') {
                    paramsReq.is_level = "true";
                    paramsReq.level_id = level_id;
                }
            } else if (via_cat === 'true') {
                paramsReq.via_cat = "true";
                paramsReq.cat_id = catId;
            }

            let jsonString = JSON.stringify(paramsReq);
            let encodedUrl = btoa(jsonString);
            let pathname = `/courseDetail/${courseId}?c=${encodedUrl}`
            // let pathname = `/courseDetail/${courseId}?source=${source}&cid=${cid}&from=${from}`
            // console.log('VIA LP', via_lp, lp_id)
            // if (from==="lp"||via_lp === "true") {
            //     pathname += `&via_lp=true&lp_id=${lp_id}&lp_source=${lp_source}`
            //     if (is_level === 'true') {
            //         pathname += `&is_level=true&level_id=${level_id}`
            //     }
            // } else if (via_cat === 'true') {
            //     pathname += `&via_cat=true&cat_id=${catId}`
            // }
            navigate(pathname,
                {
                    state: {
                        courseId: courseID,
                        courseCode: courseId,
                        courseTitle: title,
                        courseProgress: progress,
                        mId: m.module_id,
                        module: m
                    }
                }
            )
        }
    }

    return (
        <>
            {false && <Loader start={isLoading} />}
            <Page>
                <ModuleSectionB2C
                    navigateToDetails={navigateToDetails}
                    moduleListData={moduleData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    isMobile={false}

                />
                <RecommendationDetailPage isMobile={false}/>
            </Page>
        </>

    )
}
export default ModuleDetail;